export default "__VITE_ASSET__X6D$PAJN__"